export const SUPPLIER_LIST_KEY = 'SUPPLIER_LIST';
export const SUPPLIER_LIST_CLEAN_KEY = 'SUPPLIER_LIST_CLEAN_KEY';
export const SUPPLIER_ONE_KEY = 'SUPPLIER_ONE_KEY';

export const SUPPLIER_ANALYTIC_REPORT_SALE = 'SUPPLIER_ANALYTIC_REPORT_SALE';
export const SUPPLIER_STORE_DISTRIBUTION_SUMMARY = 'SUPPLIER_STORE_DISTRIBUTION_SUMMARY';

export const SUPPLIER_ANALYTIC_REPORT_SALE_PROVINCE_KEY = 'pv';
export const SUPPLIER_USERS_KEY = 'SUPPLIER_USERS_KEY';
export const SUPPLIER_ROLES_KEY = 'SUPPLIER_ROLES_KEY';

export const SUPPLIER_WAREHOUSE_LIST_KEY = 'SUPPLIER_WAREHOUSE_LIST_KEY';
